import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = logged out, obj = logged in
  useEffect(() => {
    const token = localStorage.getItem("brandops_token");
    if (!token) {
      setUser(false);
      return;
    }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem("brandops_token");
      setUser(false);
    });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("brandops_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const demoLogin = async () => {
    const { data } = await api.post("/auth/demo-login");
    localStorage.setItem("brandops_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    localStorage.setItem("brandops_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_e) { /* ignore */ }
    localStorage.removeItem("brandops_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, demoLogin, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
